import type { api } from "~/utils/api"

/**
 * Invalidates every capacity context query. Both vendor-capacity views read from their own
 * query — `getOverallCapacityContext` (vendor management) and `getCapacityContextForVendors`
 * (both buy-level Vendor Capacity tabs) — so anything that changes POs, buys or vendor settings
 * has to drop both, or the buy tab keeps showing pre-change data until a hard refresh.
 */
export function invalidateCapacityContexts(utils: ReturnType<typeof api.useUtils>) {
  return Promise.all([
    utils.capacity.getOverallCapacityContext.invalidate(),
    utils.capacity.getCapacityContextForVendors.invalidate(),
    utils.vendor.getMonthlyOrders.invalidate(),
  ])
}
